import React, {useEffect} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import gql from "graphql-tag";
import GraphQLErrors from "../../components/GraphQLErrors";
import {graphql} from "react-apollo";
import NoteItem from "./NoteItem";
import { fromJS } from "immutable";

const tableColumns = fromJS([
  {title: "Title"},
  {title: "Type"},
  {title: "Tags"}
]);

function NotesList(props) {
  let {loading, error, notes} = props.data;
  let data = props.data;
  let subscribeToUpdates = props.subscribeToUpdates
  let {onDeleted} = props;

  useEffect(() => {
    let unsubscribeToUpdates = props.subscribeToUpdates(data, onDeleted);
    let unsubscribeToNew = props.subscribeToNewData(data);

    return function() {
      unsubscribeToUpdates();
      unsubscribeToNew();
    }
  }, [subscribeToUpdates, data, onDeleted]);

  if (error) return <GraphQLErrors error={error} />

  function handleItemClick(itemData, _e, _field = "") {
    let id = itemData.get("noteId");
    props.onSelectionChange(id);
  }  

  // While content is loading we set data as empty array
  const notesData = fromJS(notes || []);

  return (
    <div>
      <Table
        loading={loading}
        data={notesData.get("entries")}
        renderer={NoteItem}
        tableHeader={tableColumns}
        onItemClick={handleItemClick}
        extraClassName="NotesList"
        itemKey="noteId"
        mode="table"
        selected={props.selectedId}
        showCount={true}
        />
    </div>
  );

}

const NOTES_QUERY = gql`
  query notes($filter:NotesFilterInput, $pagination:PaginationInput) {
    notes(filter:$filter, pagination:$pagination) {
      entries {
        noteId
        foreignId
        foreignType
        status
        title
        tags
        createdBy
        createdByName
        updatedBy
        updatedByName
        insertedAt
        updatedAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`

const ON_UPDATED_NOTE = gql`
  subscription updatedNote($noteId:ID!){
    updatedNote(noteId: $noteId) {
      id
      action
    }
  }
`

const ON_NEW_NOTE = gql`
  subscription newNote($topic:String!){
    newNote(topic: $topic) {
      id
      action
    }
  }
`

const withQuery = graphql(NOTES_QUERY, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        ...props.filters,
        status: props.statusFilter,
        foreignType: props.foreignTypeFilter,
        tag: props.tagFilter
      }
    }
  })
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  subscribeToNewData: (data) => {
    return data.subscribeToMore({
      document: ON_NEW_NOTE,
      variables: {
        topic: "*"
      },
      updateQuery: (prev, { subscriptionData }) => {
        data.refetch();
        return prev;
      }
    })
  },
  subscribeToUpdates: (data, onDeleted) => {
    return data.subscribeToMore({
      document: ON_UPDATED_NOTE,
      variables: {
        noteId: "*"
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (subscriptionData.data.updatedNote.action === "deleted") {
          onDeleted(subscriptionData.data.updatedNote.id);
          data.refetch();
        }
        // We don't do anything when "updated".
        return prev;
      }
    })
  },
});



export default connect(null, mapDispatchToProps)(withQuery(NotesList));